// extracted by mini-css-extract-plugin
export default {"Header":"Publishers_Header__A7cZl"};